import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import { createEFPic } from '@/utils/useEFPic';

const { EFPic } = createEFPic('/media/delta2/h5/');
export default function BuiltLonger({}: any) {
    const { useLang } = useGlobal();
    const { t } = useLang('delta2portablepowerstation');

    return (
        <div className={`${css.builtLonger} builtLonger GtmModuleData-section`} data-section-id={css.builtLonger} data-section-title={t('delta2.aniI_msg1')}>
            <div className="h-box">
                <div className="h-title">{t('delta2.aniI_msg1')}</div>
                <div className="h-tip">{t('delta2.aniI_msg2')}</div>
                <div className="h-sub">{t('delta2.aniI_msg3')}</div>
                <div className="h-des">
                    {t.rich('delta2.aniI_msg4', {
                        small: (text: string) => <span className="small">{text}</span>,
                    })}
                </div>
            </div>
            <div className="h-img">
                <div className="msg">{t('delta2.aniI_msg0')}</div>
                <EFPic name={['6xlonger.webp', '6xlonger.jpg']} />
            </div>
        </div>
    );
}
